import { useEffect, useState } from "react";

import { AjaxResult } from "../../../enums/ajaxResult";
import { useApi } from "../../useApi";

export function useIsFederatedSsoEnabled(orgId: number | undefined): boolean {
    const [isFederatedSsoEnabled, setIsFederatedSsoEnabled] = useState(false);

    const { orgApi } = useApi();

    useEffect(() => {
        setIsFederatedSsoEnabled(false);
        if (!orgId) return;
        let cancel = false;
        orgApi.getById(orgId).then((r) => {
            if (!cancel && r.result === AjaxResult.Success && r.data) {
                setIsFederatedSsoEnabled(r.data.isFederatedSsoEnabled === true);
            }
        });
        return () => {
            cancel = true;
        };
    }, [orgId, orgApi]);


    return isFederatedSsoEnabled;
}
